<template>
  <card class="form-card">
    <template slot="header">
      <div class="form-title">{{ title }}</div>
      <div class="form-explainer" v-html="explainer"></div>
    </template>
  </card>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  export default {
    components: {
      Card,
    },
    data: function () {
      return {
        title: "Password Reset",
        explainer: "Your password has been set. You may go ahead and <a href='/login'>login</a> now."
      }
    },
  }
</script>